import {
  getEventActionName,
  getStartActionName,
  getSuccessActionName,
} from "../../core/make-action";
import TopLevelMethod from "../../core/TopLevelMethod";
import ViewerEvent from "../../core/ViewerEvent";

const initialState = {
  isbn: null,
  isReady: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case getStartActionName(TopLevelMethod.CREATE_PAGE_VIEWER):
    case getStartActionName(TopLevelMethod.CREATE_SNIPPET_VIEWER):
      const initParams = action.apiCallArgs[0];
      return {
        ...state,
        isbn: initParams.contentId,
        snippetRange: initParams.range,
      };
    case getSuccessActionName(TopLevelMethod.CREATE_PAGE_VIEWER):
    case getSuccessActionName(TopLevelMethod.CREATE_SNIPPET_VIEWER):
      return {
        ...state,
        isReady: true,
      };
    case getEventActionName(ViewerEvent.NAVIGATION_REQUESTED):
      return {
        ...state,
        snippetRange: undefined,
      };
    default:
      return state;
  }
}
